import { Avatar, Box, Button, CircularProgress, Stack } from "@mui/material";
import React, { useEffect } from "react";
import {
  ButtonStyle,
  Color,
  FontStyle,
  settingsButtonStyle,
} from "../constants";
import { useDispatch, useSelector } from "react-redux";
import { isLoggedIn } from "../utils/utils";
import * as apiService from "../service/ApiService";
import DeleteIcon from "@mui/icons-material/Delete";

const size = "160px";

const maxMb = 4;
const maxMbString = maxMb + " MB";
const maxMbInt = maxMb * 1000000;

const uploadFile = (handleUploadToServer, file) => {
  const size = file.size;
  console.log("size", size);
  if (size > maxMbInt) {
    alert("File size must be less than " + maxMbString);
    return;
  }
  const reader = new FileReader();
  reader.onloadend = () => {
    handleUploadToServer(reader.result, file.name, file);
  };
  reader.readAsDataURL(file);
};
// should be in Profile settings panel
const ProfilePicManager = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const loggedIn = isLoggedIn(auth);
  const [loading, setLoading] = React.useState(false);
  const [uploading, setUploading] = React.useState(false);
  const [formHovered, setFormHovered] = React.useState(false);
  const [deleteHovered, setDeleteHovered] = React.useState(false);

  useEffect(() => {
    if (!loggedIn) return;
    if (!auth.loadedProfilePic) {
      apiService.getOwnProfilePic(dispatch, null, { ...auth.accountData }, {});
    }
  }, [loggedIn, auth.loadedProfilePic]);
  if (!loggedIn) return null;
  const handleUploadToServer = (img, name, rawFile) => {
    setUploading(true);
    apiService.uploadProfilePic(
      dispatch,
      { ...auth.accountData, fileData: rawFile, fileName: name, scale: 1 },
      {
        handleFinish: () => {
          setUploading(false);
        },
      }
    );
  };
  const deleteOwnProfilePic = () => {
    setUploading(true);
    apiService.deleteOwnProfilePic(
      dispatch,
      null,
      { ...auth.accountData },
      {
        handleFinish: () => {
          setUploading(false);
        },
      }
    );
  };
  const handleChange = function (e) {
    console.log("img change", e);
    e.preventDefault();
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      uploadFile(handleUploadToServer, file);
    }
  };
  return (
    <Stack
      direction="column"
      sx={{
        width: "100%",
        paddingBottom: "12px",
        textAlign: "center",
        // border: "1px solid rgb(204, 204, 204)",
        // borderRadius: "10px",
        // py: 2,
        // px: 4,
      }}
      alignItems="center"
      spacing={2}>
      {/* <Box
        sx={{
          ...FontStyle.headingBody,
          fontSize: "20px",
        }}>
        Profile Picture
      </Box> */}
      <form
        //   onDragEnter={handleDrag}
        onSubmit={(e) => e.preventDefault()}
        onMouseEnter={() => setFormHovered(true)}
        onMouseLeave={() => setFormHovered(false)}
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
        }}>
        <Box
          onMouseEnter={() => setDeleteHovered(true)}
          onMouseLeave={() => setDeleteHovered(false)}
          onClick={deleteOwnProfilePic}
          sx={{
            position: "absolute",
            top: "3px",
            right: "3px",
            zIndex: "101",
            color: deleteHovered ? "#f008" : "#fff",
            cursor: "pointer",
            display:
              uploading || auth.profilePicUrl === null ? "none" : "block",
          }}>
          <DeleteIcon />
        </Box>
        <Stack
          direction="column"
          alignItems="center"
          justifyContent="center"
          sx={{
            ...FontStyle.headingBody,
            color: "#fff",
            position: "absolute",
            top: "0px",
            left: "0px",
            width: "100%",
            height: "100%",
            backgroundColor: "#00000040",
            borderRadius: "10px",
            zIndex: "100",
            pointerEvents: "none",
            opacity: formHovered && !uploading ? 1 : 0,
            transition: "opacity 0.2s ease-in-out",
          }}>
          <Box
            sx={{
              //   px: 2,
              width: "135px",
              py: 1,
              borderRadius: "10px",
              //   transition: "background-color 0.2s",
              backgroundColor: deleteHovered ? "#f00d" : Color.deepPurple,
            }}>
            {deleteHovered
              ? "Remove Photo"
              : auth.profilePicUrl
              ? "Change Photo"
              : "Add Photo"}
          </Box>
        </Stack>
        <input
          type="file"
          id="input-profpic-upload"
          accept="image/*"
          style={{ display: "none" }}
          onChange={handleChange}
        />
        <label
          id="label-profpic-upload"
          htmlFor="input-profpic-upload"
          style={{
            width: "100%",
            cursor: "pointer",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // backgroundColor: "green",
          }}>
          {auth.loadedProfilePic && !uploading ? (
            <Avatar
              sx={{
                width: size,
                height: size,
              }}
              src={
                auth.profilePicUrl === null ? "broken" : auth.profilePicUrl
              }></Avatar>
          ) : (
            <Stack
              sx={{
                width: size,
                height: size,
                borderRadius: "50%",
                backgroundColor: "#aaa8",
              }}
              direction="column"
              alignItems="center"
              justifyContent="center">
              <CircularProgress />
            </Stack>
          )}
        </label>
      </form>
    </Stack>
  );
};

export default ProfilePicManager;
